import { LocationTypesTranslations } from "./types";

export const deLocationTranslations: LocationTypesTranslations = {
    WAITING_ROOM: "Wartezimmer",
    HOME_DISCHARGE: "Nach Hause entlassen",
    WARD_DISCHARGE: "Stationäre Entlassung",
    ITU_DISCHARGE: "Intensivstation Entlassung",
    HDU_DISCHARGE: "Hochabhängigkeitsstation Entlassung",
    Majors: "Behandlungsraum",
    Resus: "Schockraum",
    WaitingRoom: "Wartezimmer",
    MajorBed1: "Behandlungsraum",
    MajorBed2: "Behandlungsraum",
    MajorBed3: "Behandlungsraum",
    MajorBed4: "Behandlungsraum",
    MajorBed5: "Behandlungsraum",
    MajorBed6: "Behandlungsraum",
    MajorBed7: "Behandlungsraum",
    MajorBed8: "Behandlungsraum",
    ResusBed1: "Schockraum",
    ResusBed2: "Schockraum",
    Chair1: "Wartezimmer",
    Chair2: "Wartezimmer",
    Chair3: "Wartezimmer",
    Chair4: "Wartezimmer",
    Chair5: "Wartezimmer",
    Chair6: "Wartezimmer",
    Chair7: "Wartezimmer",
    Chair8: "Wartezimmer",
    Chair9: "Wartezimmer",
    Chair10: "Wartezimmer",
    Chair11: "Wartezimmer",
    Chair12: "Wartezimmer",
    Chair13: "Wartezimmer",
    Chair14: "Wartezimmer",
    Chair15: "Wartezimmer",
    Chair16: "Wartezimmer",
    Chair17: "Wartezimmer",
    Chair18: "Wartezimmer",
    Chair19: "Wartezimmer",
    Chair20: "Wartezimmer",
};
